import { Component, OnInit, ViewChild } from '@angular/core';
import { InfoPantallaDTO } from '../../../dto/util/infoPantallaDTO';
import { UtilService } from '../../../services/util.service';
import { TramiteService } from '../../../services/tramite.service';
import {EntidadDTO, Tramite} from '../models/entidadDTO';
import { Constants } from '../../../constants/constants';
import { SeliaModalComponent } from '../selia-modal/selia-modal.component';
import { Router } from '@angular/router';
import { JustinoControlAccesoService } from '../../../services/justino-control-acceso.service';

@Component({
  selector: 'app-seleccion-entidad',
  templateUrl: './seleccion-entidad.component.html',
  styleUrl: './seleccion-entidad.component.scss',
})
export class SeleccionEntidadComponent implements OnInit {
  // Entidades
  entidades: EntidadDTO[] = [];
  // Información de la pantalla y guía interactiva
  infoPantalla!: InfoPantallaDTO;
  showGuia: boolean = true;
  
  @ViewChild(SeliaModalComponent)
  modalEle!: SeliaModalComponent

  constructor(
    private router: Router,
    private readonly utilService: UtilService,
    private readonly tramiteService: TramiteService,
    private justinoControlAccesoService: JustinoControlAccesoService
  ) {}

  ngOnInit(): void {
    // Obtener datos del usuario desde el sessionStorage
    let userData = JSON.parse(
      sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE) ?? '{}'
    );

    // Se obtiene la información del usuario respecto a la guia
    const isShowGuia = sessionStorage.getItem(Constants.SHOW_GUIA_TRAMITE) != null ? false : this.showGuia

    // Se asigna información a InfoPantallaDTO
    this.infoPantalla = {
      tituloPantalla: 'Asistente para seleccionar proceso ante las entidades',
      descripcionPantalla:
        'En esta pantalla usted podrá iniciar un proceso en alguna de las EFJE y obtener ayuda ' +
        'para seleccionar el proceso más adecuado para su solicitud',
      pasos: [
        {
          element: '#tour',
          popover: {
            title: 'Guía interactiva creación de expediente',
            description:
              'Este es un recorrido guiado interactivo que le permite conocer y familiarizarse con las opciones y funcionalidades que ofrece el sistema.',
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#navbarDropdownDetalle',
          popover: {
            title: 'Información de usuario',
            description:
              'El nombre e identificación del usuario que se encuentra conectado a la plataforma.',
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#dropdownAlertasButton',
          popover: {
            title: 'Alertas',
            description:
              'Muestra una bandeja con el número de modificaciones realizadas sobre el expediente desde la última vez que el usuario entró a este.',
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#glosario',
          popover: {
            title: 'Glosario jurídico',
            description:
              'Un glosario con conceptos y sus definiciones que le ayudarán a entender el estado de sus procesos.',
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#informacion',
          popover: {
            title: 'Información',
            description:
              'Este apartado presenta información relevante acerca de la información que se visualiza en la pantalla.',
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#arbol',
          popover: {
            title: 'Árbol de decisión inteligente',
            description:
              'Esta opción le permite encontrar el proceso adecuado para sus necesidades a través de una serie de preguntas.',
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#entidades',
          popover: {
            title: 'Listado de entidades',
            description:
              'Una lista que contiene las entidades inscritas a la plataforma y los procesos que puede iniciar con cada una.',
            side: 'bottom',
            align: 'start',
          },
        },
      ],
    };
    this.utilService.changeInfoPantalla(this.infoPantalla);

    // Si es primer inicio y debe mostrar guía
    if (userData.primerInicioSesion && isShowGuia) {
      this.utilService.iniciarGuiaInteractiva(() => {
        // callback al finalizar la guía
        this.abrirModalEle();
      });
      sessionStorage.setItem(Constants.SHOW_GUIA_TRAMITE, 'false');
    } else {
      // Si no aplica la guía => abrir modal directamente
      this.abrirModalEle();
    }

    // Se consume el servicio de listar entidades con sus respectivos trámites
    this.tramiteService.listaEntidadesYTramites().subscribe(resp => {
      this.entidades = resp.filter(
        entidad =>
          entidad.Id != Constants.ID_ENTIDAD_SUPER_SOCIEDADES_MERCANTILES
      );
      this.entidades
        .find(entidad => entidad.Id == Constants.ID_ENTIDAD_SUPER_SOCIEDADES)
        ?.Tipo_Tramite.push(
          ...(resp.find(
            entidad =>
              entidad.Id == Constants.ID_ENTIDAD_SUPER_SOCIEDADES_MERCANTILES
          )?.Tipo_Tramite ?? [])
        );
    });

    sessionStorage.removeItem(Constants.PASOS);
    sessionStorage.removeItem(Constants.LISTA_FESTIVOS);
    sessionStorage.removeItem(Constants.DEMANDADOS);
    sessionStorage.removeItem(Constants.DEMANDANTES);
    sessionStorage.removeItem(Constants.ARCHIVOS_SIC_PROCON_PASO_UNO);
    sessionStorage.removeItem(Constants.ARCHIVOS_SIC_PROCON_PASO_SIETE);
  }

  abrirModalEle() {   
    setTimeout(() => {
      this.modalEle.abrirCerrarModal();
    }, 500);
  }

  guardarTramiteEnSession(tramite: Tramite) {
    sessionStorage.setItem(Constants.TRAMITE_SELECCIONADO, JSON.stringify(tramite.Nombre_Corto));
    sessionStorage.setItem(Constants.NOMBRE_TRAMITE, tramite.Nombre_Completo);
    localStorage.setItem(Constants.TRAMITE_SELECCIONADO, JSON.stringify(tramite.Nombre_Corto));
    localStorage.setItem(Constants.NOMBRE_TRAMITE, tramite.Nombre_Completo);
  }

  registrarDominio(id_dominio: string) {}

  redirectToJustino(): void {
    this.router.navigate(['/justino/bot']);
  }
}
